import TextInput from 'components/atoms/form/TextInput/TextInput'
import { Card as InternalCard } from 'components/molecules/Card/Card'
import MultiCard from 'components/molecules/Card/MultiCard'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { FieldArray, Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Accordion, Card } from 'react-bootstrap'
import { FaPlus } from 'react-icons/fa'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import {isArrayNotEmpty, isObjectEmpty, isCompletedHotelInfoHistory} from 'utilities/JSUtil'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import HotelTextService from '../../../../services/HotelTextService'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import TextAreaInput from '../../../atoms/form/TextAreaInput/TextAreaInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './HotelOnlineDisplay.scss'

class HotelOnlineDisplay extends Component {

    constructor(props) {
        super(props)

        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
        const availableHotelContent = FormConst.HOTEL_CONTENT_DEFAULT_SECTIONS[hotelInfo.brandCode]

        if (!hotelCode || !hotelInfo) {
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            availableHotelContent: availableHotelContent !== undefined ? availableHotelContent.includes(FormConst.WEDDING_CONTENT_CODE) : false,
            error: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            initialValues: { ...this.initialValues },
            alertEditIndex: -1,
            alertDeleteIndex: -1,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }

        this.areRequiredAlertFieldsComplete = this.areRequiredAlertFieldsComplete.bind(this)
        this.successfulAlertValidation = this.successfulAlertValidation.bind(this)
    }

    initialValues = {
        'hotelDisplayLocation': '',
        'drivingDirections': '',
        'extendedDrivingDirections': '',
        'salesPitch': '',
        'hotelAlerts': []
    }

    validationSchema = Yup.object().shape({
        'hotelDisplayLocation': Yup.string()
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .max(FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.hotelDisplayLocation,
                `Maximum ${FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.hotelDisplayLocation} characters`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        'drivingDirections': Yup.string()
            .max(FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.drivingDirections,
                `Maximum ${FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.drivingDirections} characters`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        'extendedDrivingDirections': Yup.string()
            .max(FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.extendedDrivingDirections,
                `Maximum ${FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.extendedDrivingDirections} characters`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        'salesPitch': Yup.string()
            .max(FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.salesPitch,
                `Maximum ${FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.salesPitch} characters`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        'hotelAlerts': Yup.array().of(
            Yup.object().shape({
                startDate: Yup.date().required(FormConst.VALIDATION_ERROR_REQUIRED),
                endDate: Yup.date().required(FormConst.VALIDATION_ERROR_REQUIRED)
                    .min(Yup.ref('startDate'), "End date cannot be before start date"),
                text: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                    .max(FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.hotelAlerts,
                        `Maximum ${FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.hotelAlerts} characters`)
                    .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
            })
        ).max(FormConst.MAX_HOTEL_ALERTS, FormConst.VALIDATION_ERROR_MAX_HOTEL_ALERTS_REACHED)
    })

    headers = ['Type', 'Status', 'Action']

    /**
     * Lifecycle method that runs after the component mounts.
     * Gets data from the session if state is COMPLETED, otherwise from the service, and sets initial values for the form.
     */
    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let descriptions = this.state.hotelInfoCompletedHistory.newEntity?.hotelText?.descriptions;
            let initialValues = { ...this.state.initialValues }

            if (descriptions) {
                descriptions.forEach(hotelTextEntry => {
                    if (hotelTextEntry.type === 'Hotel Alert') {
                        initialValues.hotelAlerts.push({
                            text: hotelTextEntry.text,
                            startDate: hotelTextEntry.startDate.split('T')[0],
                            endDate: hotelTextEntry.endDate.split('T')[0]
                        })
                    } else {
                        initialValues[FormConst.HOTEL_TEXT_TYPE_TO_FORM_NAME[hotelTextEntry.type]] = hotelTextEntry.text || ''
                    }
                })
                this.setState({ initialValues: initialValues, error: undefined, isLoading: false })
            } else {
                this.setState({ isLoading: false })
            }
        } else {
            await HotelTextService.getHotelText({ hotelCode: this.state.hotelCode })
                .then(response => {
                    let initialValues = { ...this.state.initialValues }
                    if (response?.descriptions) {
                        response.descriptions.forEach(hotelTextEntry => {
                            if (hotelTextEntry.type === 'Hotel Alert') {
                                initialValues.hotelAlerts.push({
                                    text: hotelTextEntry.text,
                                    startDate: hotelTextEntry.startDate.split('T')[0],
                                    endDate: hotelTextEntry.endDate.split('T')[0]
                                })
                            } else {
                                initialValues[FormConst.HOTEL_TEXT_TYPE_TO_FORM_NAME[hotelTextEntry.type]] = hotelTextEntry.text || ''
                            }
                        })
                        this.setState({ initialValues: initialValues, error: undefined, isLoading: false })
                    } else {
                        this.setState({ isLoading: false })
                    }
                }).catch(error => {
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while reading Hotel Online Display data'
                    })
                });
        }
    }

    handleSubmit = (formData) => {
        let putData = {
            hotelCode: this.state.hotelCode,
            descriptions: []
        }

        for (const hotelTextType in formData) {
            if (Object.hasOwnProperty.call(formData, hotelTextType)) {
                const hotelTextEntry = formData[hotelTextType];
                if (hotelTextType === 'hotelAlerts') {
                    hotelTextEntry.forEach(alert => {
                        putData.descriptions.push({
                            type: FormConst.HOTEL_TEXT_FORM_NAME_TO_TYPE[hotelTextType],
                            text: alert.text,
                            startDate: alert.startDate + 'T00:00:00',
                            endDate: alert.endDate + 'T00:00:00'
                        })
                    })
                } else {
                    if (hotelTextEntry) {
                        putData.descriptions.push({
                            type: FormConst.HOTEL_TEXT_FORM_NAME_TO_TYPE[hotelTextType],
                            text: hotelTextEntry
                        })
                    }
                }
            }
        }
        this.props.onPut(putData)
        this.setState({
            showUpdateModal: true,
            actionPerformed: this.areRequiredFieldsComplete(formData)
                ? FormConst.ACTION_SAVE_AND_PROCEED : FormConst.ACTION_SAVE
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    error: this.props.errorMessage,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                    showUpdateModal: false,
                    isLoading: false
                })
            } else {
                if (this.state.actionPerformed === FormConst.ACTION_SAVE_AND_PROCEED) {
                    let routeTo = this.state.availableHotelContent
                                  ? RouteConst.ROUTE_HOTEL_CONTENT_PAGE
                                  : RouteConst.ROUTE_POLICIES_PAGE
                    this.props.history.push(routeTo)
                } else {
                    this.setState({
                        isLoading: false,
                        showUpdateModal: false,
                        errorMessage: undefined,
                        alertEditIndex: -1
                    })
                }
            }
        }
    }

    createNewAlert = (values, arrayHelpers) => {

        let newAlert = {
            startDate: '',
            endDate: '',
            text: ''
        }

        arrayHelpers.push(newAlert)

        this.setState({
            alertEditIndex: values.hotelAlerts.length,
            isNewEntry: true
        })

    }

    onDeleteAlert = (arrayHelpers) => {
        arrayHelpers.remove(this.state.alertDeleteIndex)

        this.setState({
            showDeleteModal: false,
            alertDeleteIndex: -1,
        })
    }

    areRequiredFieldsComplete = (values) => {
        return values.hotelDisplayLocation
            && values.drivingDirections
            && values.salesPitch
    }

    areRequiredAlertFieldsComplete = (values) => {
        return values.hotelAlerts[this.state.alertEditIndex].startDate
            && values.hotelAlerts[this.state.alertEditIndex].endDate
            && values.hotelAlerts[this.state.alertEditIndex].text
    }

    successfulAlertValidation = (errors) => {
        if (errors === undefined || errors.hotelAlerts === undefined || !Array.isArray(errors.hotelAlerts)) {
            return true
        }

        errors.hotelAlerts.forEach((error) => {
            if (error !== undefined) {
                return false
            }
        })
    }

    render() {
        return (
            <div className='hotel-online-display'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to='/'>Home</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">Hotel Online Display</li>
                    </ol>
                </nav>
                <div>
                    <p className='text-left hotel-online-display-helper-text'>{FormConst.HOTEL_ONLINE_DISPLAY_HEPLER_TEXT}</p>
                </div>

                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting }) => {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                    }}>
                    {
                        ({ values, errors, isSubmitting, handleChange, validateForm, setErrors }) => (
                            <Form className='hotel-text-form-element'>

                                <Accordion id='hotel-text-accordion' className='hotel-text-accordion'>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} eventKey="0">
                                            <FaPlus /> Hotel Display Location*
                                                <span className='float-right'>{values.hotelDisplayLocation !== '' ? FormConst.VALUE_COMPLETE : FormConst.VALUE_PENDING}</span>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="0">
                                            <Card.Body>
                                                <p className='helper-text'>{FormConst.HOTEL_DISPlAY_LOCATION_HELPER_TEXT}</p>
                                                <TextAreaInput
                                                    id='hotel-display-location-text-area'
                                                    name='hotelDisplayLocation'
                                                    maxLength={FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.hotelDisplayLocation}
                                                    rows={10}
                                                    title='Hotel Display Location' />
                                                <p className='float-right'>Characters left: {FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.hotelDisplayLocation - values.hotelDisplayLocation.length}</p>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} eventKey="1">
                                            <FaPlus /> Driving Directions*
                                                <span className='float-right'>{values.drivingDirections !== '' ? FormConst.VALUE_COMPLETE : FormConst.VALUE_PENDING}</span>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="1">
                                            <Card.Body>
                                                <p className='helper-text'>{FormConst.DRIVING_DIRECTIONS_HELPER_TEXT}</p>
                                                <TextAreaInput
                                                    id='driving-directions-text-area'
                                                    name='drivingDirections'
                                                    maxLength={FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.drivingDirections}
                                                    rows={10}
                                                    title='Driving Directions' />
                                                <p className='float-right'>Characters left: {FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.drivingDirections - values.drivingDirections.length}</p>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} eventKey="2">
                                            <FaPlus /> Extended Driving Directions
                                                <span className='float-right'>{values.extendedDrivingDirections !== '' ? FormConst.VALUE_COMPLETE : FormConst.VALUE_PENDING}</span>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="2">
                                            <Card.Body>
                                                <p className='helper-text'>{FormConst.EXTENDED_DRIVING_DIRECTIONS_HELPER_TEXT}
                                                </p>
                                                <TextAreaInput
                                                    id='extended-driving-directions-text-area'
                                                    name='extendedDrivingDirections'
                                                    maxLength={FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.extendedDrivingDirections}
                                                    rows={10}
                                                    title='Extended Driving Directions' />
                                                <p className='float-right'>Characters left: {FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.extendedDrivingDirections - values.extendedDrivingDirections.length}</p>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} eventKey="3">
                                            <FaPlus /> Sales Pitch*
                                                <span className='float-right'>{values.salesPitch !== '' ? FormConst.VALUE_COMPLETE : FormConst.VALUE_PENDING}</span>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="3">
                                            <Card.Body>
                                                <p className='helper-text'>{FormConst.SALES_PITCH_HELPER_TEXT}</p>
                                                <TextAreaInput
                                                    id='sales-pitch-text-area'
                                                    name='salesPitch'
                                                    maxLength={FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.salesPitch}
                                                    rows={10}
                                                    title='Sales Pitch' />
                                                <p className='float-right'>Characters left: {FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.salesPitch - values.salesPitch.length}</p>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} eventKey="4">
                                            <FaPlus /> Hotel Alerts
                                                <span className='float-right'>{isArrayNotEmpty(values.hotelAlerts) ? FormConst.VALUE_COMPLETE : FormConst.VALUE_PENDING}</span>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="4">
                                            <>
                                                <Card.Body>
                                                    <p className='helper-text'>{FormConst.HOTEL_ALERTS_HELPER_TEXT}</p>
                                                </Card.Body>
                                                {
                                                    <FieldArray
                                                        name='hotelAlerts'
                                                        render={arrayHelpers => (
                                                            <>
                                                                {
                                                                    this.state.alertEditIndex === -1 && values.hotelAlerts.length > 0
                                                                    &&
                                                                    <>
                                                                        <MultiCard
                                                                            id='hotel-alerts-card'
                                                                            data={
                                                                                values.hotelAlerts.map((alert, index) => {
                                                                                    return {
                                                                                        text: <dl>
                                                                                            <dt>Start Date</dt>
                                                                                            <dd>{alert.startDate}</dd>
                                                                                            <dt>End Date</dt>
                                                                                            <dd>{alert.endDate}</dd>
                                                                                            <dt>Description</dt>
                                                                                            <dd>{alert.text}</dd>
                                                                                        </dl>,
                                                                                        actions: this.state.alertEditIndex === -1 ? [{
                                                                                            label: 'Edit',
                                                                                            onClick: () => {
                                                                                                this.setState({
                                                                                                    alertEditIndex: index,
                                                                                                    alertEditEntry: { ...alert }
                                                                                                })
                                                                                            }
                                                                                        },
                                                                                        {
                                                                                            label: 'Delete',
                                                                                            onClick: () => {
                                                                                                this.setState({
                                                                                                    showDeleteModal: true,
                                                                                                    alertDeleteIndex: index
                                                                                                })
                                                                                            }
                                                                                        }] : []
                                                                                    }
                                                                                })
                                                                            }
                                                                            actions={[
                                                                                {
                                                                                    'onClick': () => this.createNewAlert(values, arrayHelpers),
                                                                                    'label': '(+) Add Hotel Alert'
                                                                                }
                                                                            ]}
                                                                            isFill />

                                                                        {
                                                                            errors.hotelAlerts === FormConst.VALIDATION_ERROR_MAX_HOTEL_ALERTS_REACHED &&
                                                                            <p className="error text-center mt-5">{FormConst.VALIDATION_ERROR_MAX_HOTEL_ALERTS_REACHED}</p>
                                                                        }
                                                                    </>
                                                                }
                                                                
                                                                {
                                                                    this.state.alertEditIndex === -1 && values.hotelAlerts.length === 0
                                                                    &&
                                                                    <MultiCard
                                                                        id='hotel-alerts-card'
                                                                        text='There are no alerts configured right now.'
                                                                        actions={[
                                                                            {
                                                                                'onClick': () => this.createNewAlert(values, arrayHelpers),
                                                                                'label': '(+) Add Hotel Alert'
                                                                            }
                                                                        ]}
                                                                        isFill />
                                                                }
                                                                {
                                                                    this.state.alertEditIndex !== -1
                                                                    &&
                                                                    <InternalCard id='alert-details' text={
                                                                        <>
                                                                            <p className='hotel-online-display-title'>Alert Details</p>
                                                                            <TextInput
                                                                                id={`hotel-alert-${this.state.alertEditIndex}-start-date`}
                                                                                name={`hotelAlerts.${this.state.alertEditIndex}.startDate`}
                                                                                type='date'
                                                                                label='Start Date'
                                                                                isrequired='true' />
                                                                            <TextInput
                                                                                id={`hotel-alert-${this.state.alertEditIndex}-end-date`}
                                                                                name={`hotelAlerts.${this.state.alertEditIndex}.endDate`}
                                                                                type='date'
                                                                                label='End Date'
                                                                                isrequired='true' />
                                                                            <TextAreaInput
                                                                                id={`hotel-alert-${this.state.alertEditIndex}-text`}
                                                                                name={`hotelAlerts.${this.state.alertEditIndex}.text`}
                                                                                label='Text'
                                                                                maxLength={FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.hotelAlerts}
                                                                                rows={10}
                                                                                isrequired='true' />
                                                                            <p className='float-right'>Characters left: {FormConst.HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.hotelAlerts - values.hotelAlerts[this.state.alertEditIndex].text.length}</p>
                                                                            {/* {errors.hotelAlerts && <p className='text-red'>Please fill in the required fields</p>} */}
                                                                        </>
                                                                    }
                                                                    actions={[
                                                                        {
                                                                            'onClick': () => {
                                                                                validateForm()
                                                                                    .then(() => {
                                                                                        if (this.areRequiredAlertFieldsComplete(values) && this.successfulAlertValidation(errors)){
                                                                                            this.setState({
                                                                                                alertEditIndex: -1,
                                                                                                alertEditEntry: undefined,
                                                                                                isNewEntry: false
                                                                                            })
                                                                                        }
                                                                                    })
                                                                            },
                                                                            'label': 'Save'
                                                                        },
                                                                        {
                                                                            'onClick': () => {
                                                                                if (this.state.isNewEntry) {
                                                                                    arrayHelpers.remove(this.state.alertEditIndex)
                                                                                } else {
                                                                                    arrayHelpers.replace(this.state.alertEditIndex, {
                                                                                    ...this.state.alertEditEntry
                                                                                    })
                                                                                }
                                                                                setErrors({})
                                                                                this.setState({
                                                                                    alertEditIndex: -1,
                                                                                    alertEditEntry: undefined,
                                                                                    isNewEntry: false
                                                                                })
                                                                            }
                                                                            , 'label': 'Discard'
                                                                        }
                                                                    ]} />
                                                                }

                                                            <FormModal
                                                                id='hotel-online-display-page-delete-modal'
                                                                hotelInfo={this.state.hotelInfo}
                                                                title={'Delete Hotel Alert'}
                                                                body={<h6>{FormConst.MODAL_DELETE_ACTION_TEXT}</h6>}
                                                                proceed={() => this.onDeleteAlert(arrayHelpers)}
                                                                cancel={() => { this.setState({ showDeleteModal: false, alertDeleteIndex: -1 }) }}
                                                                show={this.state.showDeleteModal} />
                                                            </>
                                                        )}/>
                                                }
                                            </>
                                        </Accordion.Collapse>
                                    </Card>
                                </Accordion>

                                {
                                    // Show an alert message when there are errors
                                    !isObjectEmpty(errors) &&
                                    <p className="error text-center mt-5">Please fill in all the pending fields before saving</p>
                                }

                                <FormFooter
                                    form={this.state.availableHotelContent ? SideNavEntryMapping.HOTEL_TEXT : SideNavEntryMapping.HOTEL_TEXT_NO_CONTENT }
                                    isSubmit
                                    submitName={
                                        this.areRequiredFieldsComplete(values)
                                            ? FormConst.SAVE_BUTTON_TEXT
                                            : FormConst.SAVE_ONLY_BUTTON_TEXT
                                    }
                                    noReset
                                    submitDisabled={isSubmitting || !isObjectEmpty(errors)} />
                                <FormModal
                                    id='hotel-online-display-page-loading-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{this.state.loadingMessage}</h6>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='hotel-online-display-page-update-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    body={<h5>{FormConst.MODAL_UPDATE_ACTION_TEXT}</h5>}
                                    show={this.state.showUpdateModal}
                                    isLoadingIndicator />
                                <FormModal
                                    id='hotel-online-display-page-error-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    body={<h5>{this.state.errorMessage}</h5>}
                                    isError
                                    cancel={() => { this.setState({ showErrorModal: false }) }}
                                    show={this.state.showErrorModal} />
                            </Form>
                        )
                    }
                </Formik>
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        hotelTextResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_HOTEL_ONLINE_DISPLAY_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_ONLINE_DISPLAY_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(HotelOnlineDisplay, SideNavEntryMapping.HOTEL_TEXT))